import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";

interface ICustomListSelectFieldProps {
  value: Option | null;
  setValue: (value: Option | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export const CustomListSelectField = ({
  value,
  setValue,
  schema,
  labelledById,
}: ICustomListSelectFieldProps) => {
  return (
    <RadioGroup>
      {schema?.optionChoices?.map((option, idx) => (
        <FormControlLabel
          key={idx}
          value={value?.id || null}
          checked={value?.id == option.id}
          onChange={() =>
            setValue({
              colour: option.colour,
              value: option.value,
              id: option.id,
            })
          }
          control={<Radio aria-labelledby={labelledById} value={option.id} />}
          label={option.value}
        />
      ))}
    </RadioGroup>
  );
};
